import { axiosJwt } from '@/shared/auth/axiosJwt';

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_LICITACOES_PORT}${process.env.VUE_APP_API_PATH}/licitacoes`;

export default {
    documentacaoRecebida(idDaSolicitacao) {
        return axiosJwt.post(`${api}/dispensa/${idDaSolicitacao}/documentacaorecebida`);
    },
};
